import { useEffect, useState } from "react";
import { CombinedError, useQuery } from "urql";

import { graphql } from "@/gen";
import { SearchTournamentsQuery } from "@/gen/graphql";

export type Tournament = SearchTournamentsQuery["searchTournaments"][number];

type UseSearchTournamentsResult = {
    tournaments: Tournament[];
    hasMore: boolean;
    tournamentCount: number | null;
    pageCounts: number | null;
    loading: boolean;
    error?: CombinedError | null;
    refetch: () => void;
};

export const useSearchTournaments = ({
    query,
    pause = false,
}: {
    query: string;
    pause?: boolean;
}): UseSearchTournamentsResult => {
    const [tournaments, setTournaments] = useState<Tournament[]>([]);

    const [result, refetch] = useQuery({
        query: graphql(`
            query searchTournaments($query: String!) {
                searchTournaments(query: $query) {
                    id
                    title
                    tournamentSeriesId
                }
            }
        `),
        variables: {
            query,
        },
        pause,
    });

    useEffect(() => {
        if (result.data?.searchTournaments) {
            setTournaments(result.data.searchTournaments);
        }
    }, [result.data?.searchTournaments]);

    return {
        tournaments: tournaments,
        hasMore: false,
        tournamentCount: result.data?.searchTournaments?.length ?? null,
        pageCounts: result.data?.searchTournaments.length ? 1 : null,
        loading: result.fetching,
        error: result.error,
        refetch,
    };
};
